export default __webpack_public_path__ + "static/media/stripe-connection.8e01e340.webp";